import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import { useProfileData } from './useProfileData';
import { useReusableContents } from './use-cookie-disclaimer';
import { useIsCepWhitelisted } from './useIsCepWhitelisted';

export function useTnCRedirect({
  isAuthenticated,
  isImpersonationMode,
  resellerProspect = false,
}: {
  isAuthenticated: boolean;
  isImpersonationMode: boolean;
  resellerProspect: boolean;
}) {
  const navigate = useNavigate();

  const isCepWhitelisted = useIsCepWhitelisted(resellerProspect);
  const profileData = useProfileData(resellerProspect);
  const termsData = useReusableContents({
    resellerProspect,
    strTitle: 'Terms and Conditions',
  });

  useEffect(() => {
    //Impersonation mode: TnC should be skipped
    if (isImpersonationMode) return;
    if (isAuthenticated) {
      if (!isCepWhitelisted) {
        Cookies.remove('IMOnline_CEP');
        window.location.href = `${window.location.origin}/site/login/idplogin`;
      } else if (
        !profileData.isFetching &&
        profileData.status === 'success' &&
        termsData.status === 'success' &&
        profileData.data
      ) {
        if (profileData.data.dateLastTermsConditionsAcceptance) {
          if (
            termsData.data.reusableContents.length > 0 &&
            termsData.data.reusableContents[0].documentModifiedWhen
          ) {
            const acceptanceDate = new Date(
              profileData.data.dateLastTermsConditionsAcceptance
            );
            const modifiedDate = new Date(
              termsData.data.reusableContents[0].documentModifiedWhen
            );
            if (acceptanceDate < modifiedDate) {
              navigate('/terms-and-conditions', {
                state: { isCepWhitelisted },
              });
              return;
            }
          }
        } else {
          navigate('/terms-and-conditions', {
            state: { isCepWhitelisted },
          });
          return;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isAuthenticated,
    isCepWhitelisted,
    isImpersonationMode,
    profileData.status,
    termsData.status,
    navigate,
  ]);
}
